import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from 'react-router-dom';
import clsx from 'clsx';
import {Trans} from '@ui/i18n/trans';
import {StaticPageTitle} from '@common/seo/static-page-title';
import React, {Fragment, ReactNode, useRef} from 'react';
import {useStickySentinel} from '@ui/utils/hooks/sticky-sentinel';
import {useScrollToTop} from '@common/ui/navigation/use-scroll-to-top';

interface Props {
  children: ReactNode;
  actions?: ReactNode;
}
export function RequestEditorLayout({children, actions}: Props) {
  const {isSticky, sentinelRef} = useStickySentinel();
  const {lienId} = useParams();
  const ref = useRef<HTMLDivElement>(null);

  useScrollToTop(ref);

  return (
    <Fragment>
      <StaticPageTitle>
        <Trans message="Edit request" />
      </StaticPageTitle>
      <div ref={sentinelRef} />
      <div
        ref={ref}
        className={clsx(
          'sticky top-0 z-10 my-12 transition-shadow md:my-24',
          isSticky && 'bg-paper shadow',
        )}
      ></div>
      <div className="container mx-auto items-stretch gap-30 px-24 pb-24 md:flex">
        <div className="relative flex-auto md:pl-30">{children}</div>
      </div>
      <div
        className={clsx(
          'container mx-auto flex items-center gap-24 px-24 py-14 md:items-start',
        )}
      >
        <div className="mr-auto"></div>
        {actions}
      </div>
    </Fragment>
  );
}
